/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: hooks\useEmailTemplateData.ts
 🗓️ Created: 2026-05-02
 🧩 Description:
    Implementation of the email-templates module.
────────────────────────────────────────────────────────────────*/

import { useState, useEffect } from 'react';
import { EmailTemplate, getEmailTemplateById } from '../api/emailTemplatesApi';

export const useEmailTemplateData = (id?: string, duplicateId?: string | null) => {
    const [formData, setFormData] = useState<Partial<EmailTemplate>>({
        name: '',
        slug: '',
        subject: '',
        fromName: '',
        fromEmail: '',
        htmlContent: '',
        textContent: '',
        variables: [],
        isActive: true,
    });
    const [baseline, setBaseline] = useState<Partial<EmailTemplate>>({});
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const loadData = async () => {
            const targetId = id === 'new' ? duplicateId : id;
            if (!targetId || targetId === 'new') return;

            setIsLoading(true);
            try {
                const data = await getEmailTemplateById(targetId);

                let initialData = { ...data };
                if (id === 'new' && duplicateId) {
                    // Reset IDs for duplication
                    const { id: _, uuid: __, ...rest } = initialData;
                    initialData = { ...rest, name: `${rest.name} (Copy)` } as any;
                }

                setFormData(initialData);
                setBaseline(id === 'new' ? {} : initialData);
            } catch (error) {
                console.error('Error loading email template:', error);
            } finally {
                setIsLoading(false);
            }
        };

        loadData();
    }, [id, duplicateId]);

    return { formData, setFormData, baseline, setBaseline, isLoading };
};
